import { status, StatusType } from '../typeStatus'

export const GET_COMPANY_INDUSTRY = 'GET_COMPANY_INDUSTRY'
export const GET_COMPANY_INDUSTRY_SUCCEEDED = 'GET_COMPANY_INDUSTRY_SUCCEEDED'
export const GET_COMPANY_INDUSTRY_ERROR = 'GET_COMPANY_INDUSTRY_ERROR'
export const EDIT_COMPANY = 'EDIT_COMPANY'
export const EDIT_COMPANY_SUCCEEDED = 'EDIT_COMPANY_SUCCEEDED'
export const EDIT_COMPANY_ERROR = 'EDIT_COMPANY_ERROR'
export const EDIT_COMPANY_RESET = 'EDIT_COMPANY_RESET'
export const GET_COMPANY_OPTIONS = 'GET_COMPANY_OPTIONS'
export const GET_COMPANY_OPTIONS_SUCCEEDED = 'GET_COMPANY_OPTIONS_SUCCEEDED'
export const GET_COMPANY_OPTIONS_ERROR = 'GET_COMPANY_OPTIONS_ERROR'
export const EDIT_COMPANY_LOGO = 'EDIT_COMPANY_LOGO'
export const EDIT_COMPANY_LOGO_RESET = 'EDIT_COMPANY_LOGO_RESET'
export const EDIT_COMPANY_LOGO_SUCCEEDED = 'EDIT_COMPANY_LOGO_SUCCEEDED'
export const EDIT_COMPANY_LOGO_ERROR = 'EDIT_COMPANY_LOGO_ERROR'
export const GET_PROVINCES = 'GET_PROVINCES'
export const GET_PROVINCES_SUCCEEDED = 'GET_PROVINCES_SUCCEEDED'
export const GET_PROVINCES_ERROR = 'GET_PROVINCES_ERROR'
export const GET_ENCABEZADO_COMPANY = 'GET_ENCABEZADO_COMPANY'
export const GET_ENCABEZADO_COMPANY_SUCCEEDED = 'GET_ENCABEZADO_COMPANY_SUCCEEDED'
export const GET_ENCABEZADO_COMPANY_ERROR = 'GET_ENCABEZADO_COMPANY_ERROR'
export const EDIT_ENCABEZADO_COMPANY = 'EDIT_ENCABEZADO_COMPANY'
export const EDIT_ENCABEZADO_COMPANY_SUCCEEDED = 'EDIT_ENCABEZADO_COMPANY_SUCCEEDED'
export const EDIT_ENCABEZADO_COMPANY_ERROR = 'EDIT_ENCABEZADO_COMPANY_ERROR'
export const GET_BENEFICIOS_COMPANY = 'GET_BENEFICIOS_COMPANY'
export const GET_BENEFICIOS_COMPANY_SUCCEEDED = 'GET_BENEFICIOS_COMPANY_SUCCEEDED'
export const GET_BENEFICIOS_COMPANY_ERROR = 'GET_BENEFICIOS_COMPANY_ERROR'
export const EDIT_BENEFICIOS_COMPANY = 'EDIT_BENEFICIOS_COMPANY'
export const EDIT_BENEFICIOS_COMPANY_SUCCEEDED = 'EDIT_BENEFICIOS_COMPANY_SUCCEEDED'
export const EDIT_BENEFICIOS_COMPANY_ERROR = 'EDIT_BENEFICIOS_COMPANY_ERROR'

export const InitialState: CompanyProfileState = {
  statusIndustry: status.initial,
  companyIndustry: null,
  editCompany: status.initial,
  companyOptions: null,
  statusCompanyOptions: status.initial,
  editCompanyLogo: status.initial,
  provinces: null,
  statusProvinces: status.initial,
  encabezado: null,
  statusEncabezado: status.initial,
  statusEditEncabezado: status.initial,
  beneficios: null,
  statusBeneficios: status.initial,
  statusEditBeneficios: status.initial,
}

export interface SelectProps {
  id: number
  nombre: string
}

export interface Options {
  nombre: string
  habilitado: boolean
}

export interface Encabezado {
  encabezado: string
}

export interface Beneficios {
  beneficios: string
}

export interface CompanyProfileState {
  companyIndustry: SelectProps[] | null
  statusIndustry: StatusType
  editCompany: StatusType
  companyOptions: Options[] | null
  statusCompanyOptions: StatusType
  editCompanyLogo: StatusType
  provinces: SelectProps[] | null
  statusProvinces: StatusType
  encabezado: string | null
  statusEncabezado: StatusType
  statusEditEncabezado: StatusType
  beneficios: string | null
  statusBeneficios: StatusType
  statusEditBeneficios: StatusType
}

export interface EditCompanyLogo {
  type: typeof EDIT_COMPANY_LOGO
  payload: null
}

export interface EditCompanyLogoReset {
  type: typeof EDIT_COMPANY_LOGO_RESET
  payload: null
}

export interface EditCompanyLogoSucceeded {
  type: typeof EDIT_COMPANY_LOGO_SUCCEEDED
  payload: null
}

export interface EditCompanyLogoError {
  type: typeof EDIT_COMPANY_LOGO_ERROR
  payload: boolean
}

export interface Getprovinces {
  type: typeof GET_PROVINCES
  payload: null
}
export interface GetProvincesSucceeded {
  type: typeof GET_PROVINCES_SUCCEEDED
  payload: SelectProps[]
}
export interface GetProvincesError {
  type: typeof GET_PROVINCES_ERROR
  payload: boolean
}

export interface GetCompanyIndustry {
  type: typeof GET_COMPANY_INDUSTRY
  payload: null
}

export interface GetCompanyIndustrySucceeded {
  type: typeof GET_COMPANY_INDUSTRY_SUCCEEDED
  payload: SelectProps[]
}

export interface GetCompanyIndustryError {
  type: typeof GET_COMPANY_INDUSTRY_ERROR
  payload: boolean
}

export interface EditCompany {
  type: typeof EDIT_COMPANY
  payload: null
}

export interface EditCompanySucceeded {
  type: typeof EDIT_COMPANY_SUCCEEDED
  payload: null
}

export interface EditCompanyError {
  type: typeof EDIT_COMPANY_ERROR
  payload: boolean
}

export interface EditCompanyReset {
  type: typeof EDIT_COMPANY_RESET
  payload: null
}

export interface GetCompanyOptions {
  type: typeof GET_COMPANY_OPTIONS
  payload: null
}

export interface GetCompanyOptionsSucceeded {
  type: typeof GET_COMPANY_OPTIONS_SUCCEEDED
  payload: Options[]
}

export interface GetCompanyOptionsError {
  type: typeof GET_COMPANY_OPTIONS_ERROR
  payload: boolean
}

export interface GetEncabezadoCompany {
  type: typeof GET_ENCABEZADO_COMPANY
  payload: null
}

export interface GetEncabezadoCompanySucceeded {
  type: typeof GET_ENCABEZADO_COMPANY_SUCCEEDED
  payload: string
}

export interface GetEncabezadoCompanyError {
  type: typeof GET_ENCABEZADO_COMPANY_ERROR
  payload: boolean
}

export interface EditEncabezadoCompany {
  type: typeof EDIT_ENCABEZADO_COMPANY
  payload: null
}

export interface EditEncabezadoCompanySucceeded {
  type: typeof EDIT_ENCABEZADO_COMPANY_SUCCEEDED
  payload: string
}

export interface EditEncabezadoCompanyError {
  type: typeof EDIT_ENCABEZADO_COMPANY_ERROR
  payload: boolean
}

export interface GetBeneficiosCompany {
  type: typeof GET_BENEFICIOS_COMPANY
  payload: null
}

export interface GetBeneficiosCompanySucceeded {
  type: typeof GET_BENEFICIOS_COMPANY_SUCCEEDED
  payload: string
}

export interface GetBeneficiosCompanyError {
  type: typeof GET_BENEFICIOS_COMPANY_ERROR
  payload: boolean
}

export interface EditBeneficiosCompany {
  type: typeof EDIT_BENEFICIOS_COMPANY
  payload: null
}

export interface EditBeneficiosCompanySucceeded {
  type: typeof EDIT_BENEFICIOS_COMPANY_SUCCEEDED
  payload: string
}

export interface EditBeneficiosCompanyError {
  type: typeof EDIT_BENEFICIOS_COMPANY_ERROR
  payload: boolean
}

export type CompanyProfileActions =
  | GetCompanyIndustry
  | GetCompanyIndustrySucceeded
  | GetCompanyIndustryError
  | EditCompany
  | EditCompanyLogoReset
  | EditCompanyError
  | EditCompanyReset
  | EditCompanySucceeded
  | GetCompanyOptions
  | GetCompanyOptionsError
  | GetCompanyOptionsSucceeded
  | EditCompanyLogo
  | EditCompanyLogoError
  | EditCompanyLogoSucceeded
  | Getprovinces
  | GetProvincesError
  | GetProvincesSucceeded
  | GetEncabezadoCompany
  | GetEncabezadoCompanySucceeded
  | GetEncabezadoCompanyError
  | EditEncabezadoCompany
  | EditEncabezadoCompanySucceeded
  | EditEncabezadoCompanyError
  | GetBeneficiosCompany
  | GetBeneficiosCompanySucceeded
  | GetBeneficiosCompanyError
  | EditBeneficiosCompany
  | EditBeneficiosCompanySucceeded
  | EditBeneficiosCompanyError
